import { CacheProvider, ThemeProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { createTheme, CssBaseline, GlobalStyles } from '@mui/material';

import themeOptions from './themeOptions';

import getNonce from '../utils/getNonce';

export default function AppThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <CacheProvider
      value={createCache({
        key: 'nimble-energy',
        nonce: getNonce(),
        prepend: true,
      })}
    >
      <ThemeProvider theme={createTheme(themeOptions)}>
        <CssBaseline />
        <GlobalStyles
          styles={{
            '&::-webkit-scrollbar': {
              width: '5px',
              height: '5px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#888',
            },
          }}
        />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
}
